import type { Ilink } from '@nuxt-monorepo/ui/types/components/Link';
import type { ISbColorField } from '@nuxt-monorepo/ui/types';
import type { EHideOnType } from '@nuxt-monorepo/ui/types/enums/ComponentStyle';

export interface IBreadcrumbsConfig {
    _uid: string;
    component: string;
    breadcrumbs: IBreadcrumbsItem[];
    sectionBackground: ISbColorField;
    homeIconDisplay: EHomeIconDisplayType;
    hideOn: EHideOnType;
    align: string;
    linkColor: ISbColorField;
    textColor: ISbColorField;
    arrowColor: ISbColorField;
    _editable: string;
}

interface IBreadcrumbsItem {
    Text: string;
    Link: Ilink;
    _uid: string;
    component: string;
    _editable: string;
}

export enum EHomeIconDisplayType {
    Always,
    OnlyMobile,
    OnlyDesktop,
    Never,
}
